<script setup>
import PrimaryButton from "../../../../frontend/src/components/ui/PrimaryButton.vue";
import {computed, onMounted, reactive, ref} from "vue";
import useForm from "@/composables/useForm";
import marketSectorsService from "@/services/market-sectors.service";
import VueMultiselect from "vue-multiselect";
import marketSubSectorsService from "@/services/market-sub-sectors.service";

const emit = defineEmits(['saved']);

const form = reactive({
    name: "",
    sectorId: null,
})

const {populateForm, resetForm, flatErrors, setErrors, clearErrors} = useForm(form);
const showModal = ref(false);
const id = ref(null);
const loading = ref(false);
const sectorsList = ref([]);

const canSave = computed(() => form.name.length && form.sectorId);

onMounted(() => {
    getSectorsList();
});

const sector = computed({
    get() {
        return sectorsList.value.find(item => item.id === form.sectorId) || null;
    },
    set(value) {
        if (value) {
            form.sectorId = value.id;
        } else {
            form.sectorId = null;
        }
    }
});

async function getData() {
    const {data} = await marketSubSectorsService.getEdit(id.value);
    populateForm(data);
}

async function getSectorsList() {
    const {data} = await marketSectorsService.getList();
    sectorsList.value = data;
}

async function save() {
    loading.value = true;
    clearErrors();

    try {
        const {data} = await marketSubSectorsService.save(id.value, form);

        if (!Object.keys(data.errors).length) {
            showModal.value = false;
            emit('saved');
        } else {
            setErrors(data.errors);
        }
    } finally {
        loading.value = false;
    }
}

function open(itemId) {
    resetForm();
    clearErrors();

    if (itemId) {
        id.value = itemId;
        getData();
    } else {
        id.value = 0;
    }

    showModal.value = true;
}

defineExpose({open});
</script>

<template>
    <b-modal v-model="showModal" modal-class="modal-w-md" :title="(id ? 'Edit' : 'Add') + ' Sub-Sector'">
        <form class="form pb-5">
            <template v-if="flatErrors.length">
                <div class="form__error" v-for="(error, index) in flatErrors" :key="index">{{error}}</div>
            </template>

            <div class="form__item">
                <h5 class="heading5 heading5--secondary">Name *</h5>
                <input class="form-control--mid form-control" type="text" v-model="form.name">
            </div>

            <div class="form__item">
                <h5 class="heading5 heading5--secondary">Select Sector*</h5>

                <VueMultiselect
                    v-model="sector"
                    :options="sectorsList"
                    select-label=""
                    deselect-label=""
                    label="name"
                    track-by="name"
                    class="multiselect-mid pl-2"
                />
            </div>
        </form>

        <template #modal-footer>
            <PrimaryButton
                :disabled="!canSave"
                :loading="loading"
                @click="save"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
